import { Button } from "antd";
import { FilePdfOutlined } from "@ant-design/icons";
import { mobileAwareColumns, formatDate } from "../LedgerResponsive";

export const clientColumns = (openModal, openReportOptions) =>
  mobileAwareColumns([
    { title:"Name", dataIndex:"invester_name", key:"invester_name",
      render:(text,record)=><Button type="link" style={{padding:0}} onClick={()=>openModal(record)}>{text}</Button> },
    { title:"PAN", dataIndex:"pan", key:"pan",
      render:(text,record)=><Button type="link" style={{padding:0}} onClick={()=>openModal(record)}>{text}</Button> },
    { title:"DOB", dataIndex:"dob", key:"dob", responsive:["sm"], render:formatDate },
    { title:"Mobile", dataIndex:"mobile", key:"mobile", responsive:["sm"] },
    { title:"Email", dataIndex:"email", key:"email", responsive:["sm"] },
    { title:"Total Investment", dataIndex:"total_investment", key:"total_investment", responsive:["sm"],
      render:(v)=>`₹${Number(v).toLocaleString()}` },
    { title:"Redemption / Switches", responsive:["sm"], children:[
      { title:"Cost Amount", dataIndex:"redemption_cost_amount", key:"redemption_cost_amount", render:(v)=>`₹${Number(v||0).toLocaleString()}` },
      { title:"Actual Amount", dataIndex:"redemption_actual_amount", key:"redemption_actual_amount", render:(v)=>`₹${Number(v||0).toLocaleString()}` }
    ]},
    { title:"Remaining Value", children:[
      { title:"Cost", dataIndex:"remaining_cost_value", key:"remaining_cost_value", render:(v)=>`₹${Number(v||0).toLocaleString()}` },
      { title:"Current Value", dataIndex:"current_value", key:"current_value", render:(v)=>`₹${Number(v).toLocaleString()}` }
    ]},
    { title:"Absolute Return", dataIndex:"absolute_return", key:"absolute_return", responsive:["sm"], render:(val)=>{
      const value=val!=null?Number(val).toFixed(2):"0.00"; const n=parseFloat(value);
      return <span style={{fontWeight:"bold",color:n>0?"green":n<0?"red":"black"}}>{value}%</span>;
    }},
    { title:"XIRR Return", dataIndex:"xirr", key:"xirr_return", responsive:["sm"], render:(val)=>{
      const value=val!=null?Number(val).toFixed(2):"0.00"; const n=parseFloat(value);
      return <span style={{fontWeight:"bold",color:n>0?"green":n<0?"red":"black"}}>{value}%</span>;
    }},
    { title:"PDF", key:"pdf", width:60, align:"center", render:(_,record)=>(
      <Button type="text" title="Build Portfolio Report"
        icon={<FilePdfOutlined style={{fontSize:21,color:"#d32f2f"}} />}
        onClick={(e)=>{e.stopPropagation();openReportOptions(record);}} />
    )}
  ],{keepOnMobile:["invester_name","pan","current_value","absolute_return","xirr_return","pdf"]});
